import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getCategoriesListRequest, getCategoriesListRequestError, getCategoriesListRequestSuccess } from "../../slices/Content/GetCategoriesListSlice";

export const GetCategoriesListApi = () => async (dispatch) => {

    try {
        dispatch(getCategoriesListRequest());
        axiosInstance({
            method: "GET",
            url: endpoints.getCategoriesList,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCategoriesListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCategoriesListRequestError(_error));
            });
    } catch (error) { }
};
